export default __webpack_public_path__ + "static/solutionsbanner-1286277628e20b195309ac73a80a40ee.png";